/* eslint-disable jira/filename-case */
import { performPutRequest } from '@atlassian/jira-fetch/src/index.tsx';
import type { RestIssueType } from './IssueTypesForProjectsResponse.types.tsx';

type IssueTypeId = string;
type ProjectId = string;

type IssueTypeUpdatePayload = {
	name: string;
	description: string;
	avatarId: number;
};

type IssueTypeUpdateResponse = Pick<
	RestIssueType,
	'id' | 'name' | 'description' | 'avatarId' | 'hierarchyLevel'
>;

export const performUpdateIssueType = (
	issueTypeId: IssueTypeId,
	projectId: ProjectId,
	update: IssueTypeUpdatePayload,
): Promise<IssueTypeUpdateResponse> => {
	return performPutRequest<IssueTypeUpdateResponse>(
		`/rest/polaris/v2/project/${projectId}/settings/issuetype/${issueTypeId}`,
		{
			body: JSON.stringify(update),
		},
	);
};
